import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "evrideo-ag-grid-evrideo-spinning-wheel",
  templateUrl: "./ag-grid-evrideo-spinning-wheel.component.html",
  styleUrl: "./ag-grid-evrideo-spinning-wheel.component.scss",
})
export class AgGridEvrideoSpinningWheelComponent {
  @Input() tooltipText: string = "In progress...";
  @Input() progress: number = 20;
  circumference = 2 * Math.PI * 9; // 2πr
  dashOffset: number = 0;

  ngOnInit(): void {
    this.updateProgress();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["progress"]) {
      this.updateProgress();
    }
  }

  private updateProgress(): void {
    const p = this.progress < 20 ? 20 : Math.min(this.progress, 100);
    const offset = this.circumference - (p / 100) * this.circumference;
    this.dashOffset = offset;
  }
}
